const formatDate = (date:any,time:boolean=false) => {

  let day=new Date(date).getDate();
  let d=day<10?('0'+day):day;
  let month=new Date(date).getMonth()+1;
  let mo=month<10?('0'+month):month;
  let year=new Date(date).getFullYear();
  let hour=new Date(date).getHours()
  let h=hour<10?('0'+ hour):hour;
  let minute=new Date(date).getMinutes()
  let m=minute<10?('0'+ minute):minute;
  let second=new Date(date).getSeconds()
  let s=second<10?('0'+ second):second;

   if (time) {
    return d +'/'+ mo+'/'+ year+' on '+h+':' + m + ':' + s;
   } else if (date) { 
    return d +'/'+ mo+'/'+ year;
  } else return '--';
};






export default formatDate;
